/**
 *  项目的配置文件
 */

export const pexipUrl = 'https://www.meetime.com/'; //pexip的地址

export const meetingUrl = 'https://mcu.meetime.com/';// 首页会议 快捷入会跳转路径

// 与真黄页域名
export const yellowPagesUrl = 'https://yp.yoshinn.com.cn/#/';

// 租户名称
export const tenantName = "与真";

// 与真三方登录商城
export const clientId = "yuzhen";
export const responseType = "code";  // 请求类型
// 重定向地址
// export const redirectUri = "http://localhost:8108/user/loginSso";
export const redirectUri = "https://jbbcs-seller.yoshinn.com.cn/user/loginSso";

// 短信通道
export const smsChannel = 'tencent_test'; // 腾讯云
// export const smsChannel = 'amazon'; // 亚马逊

// 套餐地区
// export const pexipPackageArea = 'Japan' // 日本
export const pexipPackageArea = 'China' // 中国

export const yoshinn_help_cn = "https://static.meetime.com/meeting/yoshinn_help_cn.mp4"
export const yoshinn_help_hk = "https://static.meetime.com/meeting/yoshinn_help_hk.mp4"
export const yoshinn_help_en = "https://static.meetime.com/meeting/yoshinn_help_en.mp4"
export const yoshinn_help_jp = "https://static.meetime.com/meeting/yoshinn_help_jp.mp4"
